/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _500Inputs */



/**
* | output |
* | --- |
* | "Oops! Something went wrong on our side. Please try again later" |
*
* @param {_500Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const _500 = /** @type {((inputs?: _500Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_500Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Oops! Something went wrong on our side. Please try again later")
	return /** @type {LocalizedString} */ ("Oups ! Quelque chose s'est mal passé de notre côté. Veuillez réessayer plus tard")
});
export { _500 as "500" }